module.exports = __webpack_public_path__ + "static/media/sleepingBag.4890cff8.svg";